<template>
    <div class="e-color-picker" :class="{ 'inline': inline }">
        <template v-if="button">
            <b-btn class="btn-color-picker" :variant="variant" :size="buttonSize" :class="{'btn-squared': buttonSquared}" @click="show" :style="style">
                <slot></slot>
            </b-btn>
        </template>
        <label v-else @click="show">
            {{label}}
            <b-input type="text" v-model="value" :style="style"></b-input>
        </label>
        <e-photoshop-color-picker v-if="pickerEnabled" :value="color" @input="colorChanged" @ok="pickerEnabled = false" @cancel="cancel"/>
    </div>
</template>

<script>
    import EPhotoshopColorPicker from "./color-picker/e-photoshop-color-picker.vue";

    export default {
        name: `e-color-picker`,
        props: {
            value: {},
            button: {type: Boolean},
            variant: {type: String, default: `light`},
            buttonSize: {type: String, default: `md`},
            inline: {type: Boolean},
            buttonSquared: {type: Boolean},
            label: {type: String}
        },
        components: {
            EPhotoshopColorPicker
        },
        data() {
            return {
                pickerEnabled: false,
                // rememberedColor: null // not implemented yet
            }
        },
        computed: {
            color: {
                get() {
                    return this.value || `#000000`;
                },
                set(value) {
                    this.colorChanged(value);
                }
            },
            colorRGB() {
                return this.hexToRgb(this.color)
            },
            textColor() {
                let textColor = `black`;
                let luminance = (0.299 * this.colorRGB.r + 0.587 * this.colorRGB.g + 0.114 * this.colorRGB.b) / 255;
                if (luminance <= 0.5) // dark colors - white font
                    textColor = `white`;

                return textColor;
            },
            style() {
                return {
                    background: this.color + ` !important`,
                    color: this.textColor + ` !important`
                }
            }
        },
        methods: {
            colorChanged(colorObject) {
                this.$emit(`input`, colorObject.hex);
                this.$emit(`change`, colorObject.hex);
                this.$emit(`update:text-color`, this.textColor);
            },
            show(color = `#000000`) {
                if (!this.color) {
                    this.color = color;
                }
                this.$emit(`open-picker`);
                this.$nextTick(() => {
                    this.pickerEnabled = true;
                });
                this.$emit(`show`);
            },
            cancel(color) {
                if (color) {
                    this.colorChanged(color);
                }
                this.pickerEnabled = false;
            },
            hexToRgb(hex) {
                const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
                return result ? {
                    r: parseInt(result[1], 16),
                    g: parseInt(result[2], 16),
                    b: parseInt(result[3], 16)
                } : { r: 0, g: 0, b: 0 };
            }
        }
    }
</script>

<style lang="scss" scoped>
.btn-color-picker.btn-squared {
    width: 32px;
    height: 32px;
}

.e-color-picker {
    &.inline {
        display: inline-flex;
    }

    label {
        margin-bottom: 0;
    }
}

    .picker-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1000;
        background-color: rgba(0, 0, 0, 0.5);

        .color-picker {
            position: fixed;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);

            .vc-photoshop {
                font-family: inherit;

                .vc-ps-fields .vc-input__label,
                .vc-ps-fields .vc-input__desc {
                    color: #000;
                }
            }
        }
    }
</style>
